import axios from 'axios';
import toast from './toast';

const API_URL = process.env.REACT_APP_API_URL || 'https://crm-api.boldranksoperations.space/api';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Oturum düştüyse (süre doldu / hesap pasife alındı) sessizce boş ekran yerine giriş sayfasına dön.
// Değişiklik isteklerinde (kaydet, sil…) hata kullanıcıya gösterilsin; eskiden sadece konsola yazılıyordu.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const isLogin = String(err.config?.url || '').includes('/auth/login');
    if (status === 401 && !isLogin) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        sessionStorage.setItem('loginNotice', 'Oturumunuz sona erdi, lütfen tekrar giriş yapın.');
        window.location.assign('/login');
      }
    } else if (!isLogin && (err.config?.method || 'get') !== 'get' && !err.config?.silent) {
      const msg = err.response?.data?.error || err.response?.data?.message
        || (status === 403 ? 'Bu işlem için yetkiniz yok.' : err.response ? 'İşlem yapılamadı.' : 'Sunucuya ulaşılamadı.');
      toast(msg, 'error');
    }
    return Promise.reject(err);
  }
);

export default api;
